import { OEText, PanelLayout, mv } from '@openeducation/oe-it-components';
import * as React from 'react';

export type BoxMessageProps = {
  title: string;
  body?: string;
  divider: React.ReactNode;
  width?: string | number;
  padding?: number;
};
export const BoxMessage = ({
  divider,
  title,
  body,
  width = 700,
  padding = 80,
}: BoxMessageProps) => {
  return (
    <PanelLayout width={width} padding={padding}>
      {divider}
      <OEText fontSize={24} textAlign="center" fontType="bold" style={[mv(40)]}>
        {title}
      </OEText>
      {!!body && (
        <OEText fontSize={16} textAlign="center">
          {body}
        </OEText>
      )}
    </PanelLayout>
  );
};
